import { z } from "zod";
import { IsoDateTimeSchema } from "./common.js";

export const AnalyticsSiteIdSchema = z.enum(["default", "lp", "newbiz", "creator"]);
export const AbVariantSchema = z.enum(["A", "B"]);
export const AnalyticsEventSchema = z
	.object({
		eventId: z.string().min(1).max(200),
		occurredAt: IsoDateTimeSchema,
		siteId: AnalyticsSiteIdSchema,
		variant: AbVariantSchema,
		kind: z.enum(["page_view", "cta"]),
		sessionId: z.string().min(1).max(200),
	})
	.strict();
export type AnalyticsEvent = z.infer<typeof AnalyticsEventSchema>;

export const AnalyticsSourceSchema = z.enum(["cloudflare-web-analytics", "fixture"]);
export const AnalyticsMeasurementStatusSchema = z.enum(["COMPLETE", "PARTIAL"]);
export const FetchAnalyticsEventsRequestSchema = z.object({
	assetKey: z.literal("cf-web-analytics-agentry-stg"),
	windowStartedAt: IsoDateTimeSchema,
	windowEndedAt: IsoDateTimeSchema,
});
export const FetchAnalyticsEventsResponseSchema = z.object({
	source: AnalyticsSourceSchema,
	measurementStatus: AnalyticsMeasurementStatusSchema,
	events: z.array(AnalyticsEventSchema),
});

export const AbCountSchema = z.object({
	siteId: AnalyticsSiteIdSchema,
	variant: AbVariantSchema,
	sessions: z.number().int().min(0),
	ctaConversions: z.number().int().min(0),
});
export const AbRateSchema = z.object({
	siteId: AnalyticsSiteIdSchema,
	variant: AbVariantSchema,
	conversionRate: z.number().min(0).max(1).nullable(),
});
export const AbMetricsSchema = z.object({
	window: z.object({ startedAt: IsoDateTimeSchema, evaluatedAt: IsoDateTimeSchema }),
	source: AnalyticsSourceSchema,
	measurementStatus: AnalyticsMeasurementStatusSchema,
	counts: z.array(AbCountSchema).length(8),
	rates: z.array(AbRateSchema).length(8),
	thresholdReached: z.boolean(),
	alpha: z.literal(0.05),
	z: z.number().finite().nullable(),
	pValue: z.number().min(0).max(1).nullable(),
	winner: AbVariantSchema.nullable(),
});
export type AbMetrics = z.infer<typeof AbMetricsSchema>;
